import {NavDropdown, Row, Col, Image} from 'react-bootstrap'
import {FaChevronDown, FaLongArrowAltLeft} from "react-icons/fa"
import Link from 'next/link'

import categories from '@data/wellnessCategories'

function CategoriesNav(props) {

    function navGroup()
    {
        var nav = []
        for (var i=0; i<categories.length; i+=3) {
            nav.push(categories.slice(i,i+3))
        }
        return nav
    }

    function onClickHandler(category)
    {
       window.location.href="/"+category;
    }
    
    return (
        <div className="categoriesdropdown">
            <NavDropdown title={<div>
                <div className="d-lg-inline-block d-none">Categories <FaChevronDown className="h8 ml-1"/></div>
                <div className="d-lg-none d-inline-block">
                    <svg width="46" height="46">
                        <path d="M33.34,11.12H12.84a1.23,1.23,0,0,0-1.24,1.23V32.86a1.24,1.24,0,0,0,1.24,1.24h20.5a1.24,1.24,0,0,0,1.24-1.24V12.35A1.23,1.23,0,0,0,33.34,11.12Zm-.78,10.22H20.81V13.13H32.56ZM13.62,13.13h5.17V32.08H13.62Zm7.19,18.95V23.36H32.56v8.72Z"/>
                    </svg>
                    <span className="footer-link">Categories</span>
                </div>
            </div>}>
                <div className="px-lg-4 px-3">
                    <Row>
                        <Col xl={{span:9, offset:2}} lg={{span:8, offset:2}} className="py-3">
                            <p><Link href="#"><a className="d-lg-none d-inline-block"><FaLongArrowAltLeft size="25" className="mr-3"/></a></Link><strong>Browse Wellness Categories</strong></p>
                            <Row>
                                {navGroup().map( (d,i) => 
                                    <Col key={i} xl={3} lg={4}>
                                        { d.map( (data,idx)=> {
                                            if (data.slug == 'recipes')
                                                return (
                                                    <Link key={idx} href={`/${data.slug}`} passHref><a onClick={() => onClickHandler(data.slug)} className="d-block py-2">
                                                        <Image width={35} src={data.icon} className="mr-2"/>{data.name}
                                                    </a></Link>
                                                )
                                            return (
                                                <Link key={idx} href="/category/[slug]" as={`/category/${data.slug}`} passHref><a onClick={() => onClickHandler('category/'+data.slug)} className="d-block py-2">
                                                    <Image width={35} src={data.icon} className="mr-2"/>{data.name}
                                                </a></Link>
                                            )
                                        })}
                                    </Col>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </div>
            </NavDropdown>
        </div>
    )
}

export default CategoriesNav
